import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ChartParallel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M21 1.5V3.98032L16.5 5.66782V1.5H15V5.64218L9 3.24217V1.5H7.5V3.33435L3 6.14685V1.5H1.5V22.5H3V20.7136L7.5 18.4636V22.5H9V18.2582L15 20.0581V22.5H16.5V19.9156L21 17.1031V22.5H22.5V1.5H21ZM21 5.58218V9.375L16.5 12.75V7.26967L21 5.58218ZM15 7.2576V12.9254L9 9.32543V4.85782L15 7.2576ZM7.5 5.10315V9.40943L3 13.3469V7.91565L7.5 5.10315ZM3 19.0364V15.3406L7.5 11.4031V16.7864L3 19.0364ZM9 16.6919V11.0744L15 14.6744V18.4915L9 16.6919ZM16.5 18.1469V14.625L21 11.25V15.3344L16.5 18.1469Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ChartParallel.vue"]]);
